const PlayCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={25}
    height={24}
    {...props}
  >
    <title>play_circle_outline</title>
    <defs>
      <path
        id="a"
        d="m10 16.5 6-4.5-6-4.5v9ZM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(.5)">
      <path d="M0 0h24v24H0z" />
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <path fill="#080808" d="M0 0h24v24H0z" mask="url(#b)" />
    </g>
  </svg>
);
export default PlayCircleIcon;
